export interface RafThrottledFn {
  (): void
  cancel: () => void
}

/**
 * rAF-based throttling that guarantees the final callback after pending updates.
 */
export const rafThrottle = (callback: () => void): RafThrottledFn => {
  let rafId: number | null = null
  let hasPending = false

  const throttled = () => {
    if (rafId !== null) {
      hasPending = true
      return
    }
    const run = () => {
      rafId = null
      callback()
      if (hasPending) {
        hasPending = false
        rafId = requestAnimationFrame(run)
      }
    }
    rafId = requestAnimationFrame(run)
  }

  throttled.cancel = () => {
    hasPending = false
    if (rafId === null) return
    cancelAnimationFrame(rafId)
    rafId = null
  }

  return throttled
}
